<template>
  <div
    :class="[checkMenuColor,checkSubMenuColor,checkAnnimateMenu,checkLayoutMenu,checkPositionMenu,checkfullScreen,checkMenuImage]"
    class="menu-w sidebar selected-menu-color-light menu-has-selected-link"
  />
</template>

<script>
import TLoader from '@/components/common/loader'
import { mapGetters, mapState } from 'vuex'

export default {
	name: 'web-navbar',
	components: { TLoader },
	computed: {
		...mapGetters('User', ['user']),
		...mapState('ThemePreferences', ['subMenuColor']),
		...mapState('ThemePreferences', ['menuColor']),
		...mapState('ThemePreferences', ['menuAnnimation']),
		...mapState('ThemePreferences', ['menuLayout']),
		...mapState('ThemePreferences', ['menuPosition']),
		...mapState('ThemePreferences', ['fullScreen']),
		...mapState('ThemePreferences', ['topBar']),
		...mapState('ThemePreferences', ['menuImage']),
		...mapState('ThemePreferences', ['subTopbarColor']),

		checkMenuImage () {
			switch (this.menuImage) {
			case 'yes':
				return 'menu-with-image'
			case 'no':
				return ''
			default:
				return 'menu-with-image'
			}
		},
		checkPositionMenu () {
			switch (this.menuPosition) {
			case 'left':
				document.body.classList.remove('menu-side-right')
				document.body.classList.remove('menu-side-top')
				document.body.classList.add('menu-side-left')
				document.body.classList.add('menu-position-side')
				return 'menu-position-side menu-side-left'

			case 'right':
				document.body.classList.remove('menu-side-left')
				document.body.classList.remove('menu-side-top')
				document.body.classList.add('menu-side-right')
				document.body.classList.add('menu-position-side')
				return 'menu-position-side menu-side-right'

			case 'top':
				document.body.classList.remove('menu-side-right')
				document.body.classList.remove('menu-side-left')
				document.body.classList.add('menu-position-top')
				document.body.classList.remove('menu-position-side')
				document
					.getElementsByClassName('has-sub-menu')[0]
					.classList.add('selected')
				return 'menu-position-top'

			default:
				document.body.classList.add('menu-side-left')
				document.body.classList.add('menu-position-side')
				return 'menu-position-side menu-side-left'
			}
		},
		checkLayoutMenu () {
			switch (this.menuLayout) {
			case 'compact':
				return 'menu-layout-compact'

			case 'full':
				return 'menu-layout-full'

			case 'mini':
				return 'menu-layout-mini'

			default:
				return 'menu-layout-mini'
			}
		},
		checkAnnimateMenu () {
			switch (this.menuAnnimation) {
			case 'flyout':
				return 'sub-menu-style-flyout menu-activated-on-hover'

			case 'inside':
				return 'sub-menu-style-inside'

			case 'over':
				return 'sub-menu-style-over menu-activated-on-hover'

			default:
				return 'sub-menu-style-over menu-activated-on-hover'
			}
		},
		checkSubMenuColor () {
			switch (this.subMenuColor) {
			case 'color-light':
				return 'sub-menu-color-light'

			case 'color-bright':
				return 'sub-menu-color-bright'

			case 'color-dark':
				return 'sub-menu-color-dark'

			default:
				return 'sub-menu-color-bright '
			}
		},
		checkMenuColor () {
			switch (this.menuColor) {
			case 'color-light':
				return 'color-scheme-light color-style-default'

			case 'color-bright':
				return 'color-scheme-dark color-style-bright'

			case 'color-dark':
				return 'color-scheme-dark color-style-default'
			case 'color-transparent':
				return 'color-scheme-light color-style-transparent'
			default:
				return 'color-scheme-dark color-style-bright'
			}
		},
		checkPositionMenu () {
			switch (this.menuPosition) {
			case 'left':
				document.body.classList.remove('menu-side-right')
				document.body.classList.remove('menu-side-top')
				document.body.classList.add('menu-side-left')
				document.body.classList.add('menu-position-side')
				return 'menu-position-side menu-side-left'

			case 'right':
				document.body.classList.remove('menu-side-left')
				document.body.classList.remove('menu-side-top')
				document.body.classList.add('menu-side-right')
				document.body.classList.add('menu-position-side')
				return 'menu-position-side menu-side-right'

			case 'top':
				document.body.classList.remove('menu-side-right')
				document.body.classList.remove('menu-side-left')
				document.body.classList.add('menu-position-top')
				document.body.classList.remove('menu-position-side')

				document
					.getElementsByClassName('has-sub-menu')[0]
					.classList.add('selected')
				return 'menu-position-top'

			default:
				document.body.classList.add('menu-side-left')
				document.body.classList.add('menu-position-side')
				return 'menu-position-side menu-side-left'
			}
		}
	},
	watch: {
		subTopbarColor () {
			this.checksubTopbarColor()
		},
		topBar () {
			this.checkTopBar()
		},
		fullScreen () {
			this.checkfullScreen()
		}
	},

	methods: {
		checksubTopbarColor () {
			document.getElementsByClassName(
				'top-bar'
			)[0].style.background = this.subTopbarColor
		},
		checkTopBar () {
			switch (this.topBar) {
			case 'yes':
				document
					.getElementsByClassName('top-bar')[0]
					.classList.remove('d-none')
				break

			case 'no':
				document.getElementsByClassName('top-bar')[0].classList.add('d-none')
				break
			default:
				break
			}
		},
		checkfullScreen () {
			switch (this.fullScreen) {
			case 'yes':
				document.body.classList.add('full-screen')
				break

			case 'no':
				document.body.classList.remove('full-screen')
				break

			default:
				document.body.classList.add('full-screen')
				break
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/navbar/web/index.vue